import React from "react";
import { useAccount } from "../Contexts/AccountContext";

export default () => {
  const { selectedTab, dictionary, dispatch } = useAccount();
  
  const handleTabChange = (tab: string) => {
    dispatch({ type: 'selected-tab', data: tab });
  };
  
  return (
    <div className="bg-white h-100" style={{minHeight: 430}}>
      <div className="nav flex-column">
        <button 
          className={`btn p-3 border text-start ${selectedTab === 'overview' ? 'btn-success' : 'btn-default'}`}
          onClick={() => handleTabChange('overview')}
        >
          {dictionary.get('MyAccount:Tab:Overview') || 'Overview'}
        </button>
        <button 
          className={`btn p-3 border text-start ${selectedTab === 'zoopass' ? 'btn-success' : 'btn-default'}`}
          onClick={() => handleTabChange('zoopass')}
        >
          {dictionary.get('MyAccount:Tab:ZooPass') || 'Zoo Pass'}
        </button>
        <button 
          className={`btn p-3 border text-start ${selectedTab === 'events' ? 'btn-success' : 'btn-default'}`}
          onClick={() => handleTabChange('events')}
        >
          {dictionary.get('MyAccount:Tab:ClassNEvents') || 'Classes & Events'}
        </button>
      </div>
    </div>
  );
};